import React from 'react';
import { VotingProvider } from './contexts/VotingContext';
import VoteApp from './VoteApp';

export default function App() {
    return (
        <VotingProvider>
            <VoteApp />
        </VotingProvider>
    );
}